/**
 * Scroll Reveal System
 * Uses IntersectionObserver to reveal .reveal elements on scroll.
 * Progressive enhancement: no-JS shows all content; JS hides then reveals.
 */

export default function scrollReveal() {
  // Skip entire reveal system for users who prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Activate CSS hidden state for .reveal elements
  document.documentElement.classList.add('js-reveal-ready');

  const reveals = document.querySelectorAll('.reveal');
  if (!reveals.length) return;

  // Fallback: no IntersectionObserver support
  if (!('IntersectionObserver' in window)) {
    reveals.forEach(el => el.classList.add('revealed'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -80px 0px'
  });

  reveals.forEach(el => observer.observe(el));
}
